import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom";
import "./assets/main.css";
import App from "./App";
import store from "./store";
import { Provider } from "react-redux";
ReactDOM.render(
// <React.StrictMode>
_jsx(Provider, Object.assign({ store: store }, { children: _jsx(App, {}) })), 
// </React.StrictMode>,
document.getElementById("root"));
